export default __webpack_public_path__ + "72e539f747b33f63c2a1c627001708b4.webp";